import ButtonBack from '@components/buttons/button-back/button-back.component'
import React, { PropsWithChildren, useEffect } from 'react'
import './navigation-single.layout.scoped.scss'
import './navigation-single.layout.scss'

export interface PropsNavigation extends PropsWithChildren<React.HTMLAttributes<HTMLDivElement>> {
  header?: any
  footer?: any
  backButton?: boolean
  stickyFooter?: boolean
  stickyHeader?: boolean
  onClickBackButton?: () => any
  onReferrerFalseUrlBackButton?: string
}

export default ({
  className = '',
  id = '',
  children,
  header,
  footer,
  backButton = false,
  stickyFooter = false,
  onReferrerFalseUrlBackButton = '/',
  stickyHeader = false,
  onClickBackButton,
}: PropsNavigation) => {
  const wrapperAsideRef = React.useRef<HTMLDivElement>(null)
  const [isMobile, setIsMobile] = React.useState(false)
  const [height, setHeight] = React.useState(window?.innerHeight)
  const [width, setWidth] = React.useState(window?.innerWidth)

  useEffect(() => {
    function onScrollAside(e) {
      if (wrapperAsideRef.current) {
        wrapperAsideRef.current.style.top = `${window.pageYOffset}px`
      }
    }

    window.addEventListener('scroll', onScrollAside)
    return () => {
      window.removeEventListener('scroll', onScrollAside)
    }
  }, [wrapperAsideRef])

  useEffect(() => {
    function handleResize() {
      if (window.innerWidth > 991) {
        setIsMobile(false)
      } else if (window.innerWidth < 992) {
        setIsMobile(true)
      }
    }
    const updateHeight = () => {
      setHeight(window?.innerHeight)
    }
    const updateWidth = () => {
      setWidth(window?.innerWidth)
    }
    handleResize()
    window.addEventListener('resize', handleResize)
    window.addEventListener('resize', updateHeight)
    window.addEventListener('resize', updateWidth)
    return () => {
      window.removeEventListener('resize', handleResize)
      window.removeEventListener('resize', updateHeight)
      window.removeEventListener('resize', updateWidth)
    }
  }, [])

  return (
    <section className={`navigation-single scrollbar box ${className}`} id={id} style={{ height: width < 991 ? height : null }}>
      {backButton ? (
        <ButtonBack onClick={onClickBackButton} circleLayout className="top-back" onReferrerFalseUrl={onReferrerFalseUrlBackButton} />
      ) : null}
      {header ? <header className={`${stickyHeader ? 'sticky' : ''}`}>{header}</header> : null}
      <div className="content" id="navigation-single-content">
        {children}
      </div>
      {footer ? <footer className={`${stickyFooter ? 'sticky' : ''}`}>{footer}</footer> : null}
    </section>
  )
}
